<template>
  <div class="report-filter">
    <div v-for="(item, i) in paramsList" :key="i" class="report-filter-item">
      <div class="c_size_14">{{ item.nameDisp }}</div>
      <template v-if="item.type == 1">
        <el-select
          v-model="item.defaultvalue"
          :placeholder="item.placeholder || '请选择'"
          size="mini"
        >
          <el-option
            v-for="option in item.valueOption"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
      </template>
      <template v-else-if="item.type == 2">
        <el-select
          v-model="item.defaultvalue"
          multiple
          :placeholder="item.placeholder || '请选择'"
          size="mini"
        >
          <el-option
            v-for="option in item.valueOption"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
      </template>
      <template v-else-if="item.type == 3">
        <el-input
          style="min-width:170px"
          v-model="item.defaultvalue"
          size="mini"
          :placeholder="item.placeholder || '请输入'"
        ></el-input>
      </template>
      <template v-else-if="item.type == 4">
        <el-input
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 4 }"
          size="mini"
          :placeholder="item.placeholder || '请输入'"
          v-model="item.defaultvalue"
        ></el-input>
      </template>
      <template v-else-if="item.type == 10">
        <el-date-picker
          v-model="item.defaultvalue"
          type="year"
          size="mini"
          placeholder="选择年"
          value-format="yyyy"
        ></el-date-picker>
      </template>
      <template v-else-if="item.type == 11">
        <el-date-picker
          v-model="item.defaultvalue"
          type="month"
          size="mini"
          placeholder="选择年月"
          value-format="yyyy-MM"
        ></el-date-picker>
      </template>
      <template v-else-if="item.type == 12">
        <el-date-picker
          v-model="item.defaultvalue"
          type="date"
          size="mini"
          placeholder="选择年月日"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </template>
      <template v-else-if="item.type == 13">
        <el-date-picker
          v-model="item.defaultvalue"
          type="datetime"
          size="mini"
          placeholder="选择时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </template>
    </div>
    <el-button
      @click="getPalette"
      type="primary"
      style="align-self: flex-end;height: 28px;padding: 0 15px;margin-bottom:8px;"
      v-if="paramsList.length > 0"
    >
      查询
    </el-button>
  </div>
</template>
<script>
export default {
  props: {
    params: Array
  },
  data() {
    return {
      paramsList: this.params
    };
  },
  methods: {
    getPalette() {
      this.$emit('getPalette', this.paramsList);
    }
  }
};
</script>
<style scoped lang="scss">
.report-filter {
  display: flex;
  flex-wrap: wrap;
  .report-filter-item {
    margin-right: 10px;
    margin-bottom: 8px;
    max-width: 170px;
    .el-input--mini {
      width: 100%;
      input {
        min-width: 170px;
      }
    }
  }
}
</style>
